import { useState } from 'react';
import { AuthService } from '../../services';
import { timeoutFunc, validateEmail } from '../../utils/commonUtils';
import commonMessage from '../../configs/commonMessage';

let timeout = 0;

const useIsEmailRegistered = () => {
  const [isValidEmail, setIsValidEmail] = useState(null);
  const [isNotValidEmailMessage, setIsNotValidEmailMessage] = useState(null);
  const [isValidatingEmail, setIsValidatingEmail] = useState(false);

  const onValidate = ({ email }) => {
    if (email === '') {
      setIsNotValidEmailMessage(commonMessage.invalidType('email address'));
      setIsValidEmail(false);
    }

    if (email !== '' && !validateEmail(email)) {
      setIsNotValidEmailMessage(commonMessage.invalidType('email address'));
      setIsValidEmail(false);
    }

    timeout = timeoutFunc(
      timeout,
      () => {
        if (email !== '' && validateEmail(email)) {
          setIsValidatingEmail(true);
          setIsNotValidEmailMessage(null);
          AuthService.postEmailAvailability({
            email,
          })
            .then(() => {
              setIsNotValidEmailMessage('Email is not registered');
              setIsValidEmail(false);
            })
            .catch(() => {
              setIsNotValidEmailMessage(null);
              setIsValidEmail(true);
            })
            .finally(() => {
              setIsValidatingEmail(false);
            });
        }
      },
      2000
    );
  };

  const validateStatus = () => {
    if (isValidatingEmail) {
      return 'validating';
    }
    if (!isValidatingEmail && isValidEmail && isValidEmail !== null) {
      return 'success';
    }
    if (!isValidatingEmail && !isValidEmail && isValidEmail !== null) {
      return 'error';
    }
    return '';
  };

  return {
    isValidEmail,
    isNotValidEmailMessage,
    isValidatingEmail,
    onValidate,
    validateStatus,
  };
};

const useIsEmailAlreadyRegistered = () => {
  const [isValidEmail, setIsValidEmail] = useState(null);
  const [isNotValidEmailMessage, setIsNotValidEmailMessage] = useState(null);
  const [isValidatingEmail, setIsValidatingEmail] = useState(false);

  const onValidate = ({ email, initialEmail }) => {
    if (email === '') {
      setIsNotValidEmailMessage(commonMessage.invalidType('email address'));
      setIsValidEmail(false);
    }

    if (email !== '' && !validateEmail(email)) {
      setIsNotValidEmailMessage(commonMessage.invalidType('email address'));
      setIsValidEmail(false);
    }

    if (email !== initialEmail) {
      timeout = timeoutFunc(
        timeout,
        () => {
          if (email !== '' && validateEmail(email) && email) {
            setIsValidatingEmail(true);
            setIsNotValidEmailMessage(null);
            AuthService.postEmailAvailability({
              email,
            })
              .then(() => {
                setIsNotValidEmailMessage(null);
                setIsValidEmail(true);
              })
              .catch(() => {
                setIsNotValidEmailMessage('Email is already registered.');
                setIsValidEmail(false);
              })
              .finally(() => {
                setIsValidatingEmail(false);
              });
          }
        },
        2000
      );
    } else {
      setIsNotValidEmailMessage(null);
      setIsValidEmail(true);
    }
  };

  const validateStatus = () => {
    if (isValidatingEmail) {
      return 'validating';
    }
    if (!isValidatingEmail && isValidEmail && isValidEmail !== null) {
      return 'success';
    }
    if (!isValidatingEmail && !isValidEmail && isValidEmail !== null) {
      return 'error';
    }
    return '';
  };

  return {
    isValidEmail,
    isNotValidEmailMessage,
    isValidatingEmail,
    onValidate,
    validateStatus,
  };
};

export default {
  useIsEmailRegistered,
  useIsEmailAlreadyRegistered,
};
